import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { ChartCard, ChartEmpty } from './ChartCard';

interface TrendPoint {
  ym: string;
  avgPrice: number | null;
  dealCount: number;
}

/** 지역별 ㎡당 평균 실거래가 추이 (월별) */
export function RealEstateTrendChart({ data }: { data: TrendPoint[] }) {
  const points = data.filter((d) => d.avgPrice !== null);

  return (
    <ChartCard title="㎡당 평균 실거래가 추이" subtitle="최근 6개월">
      {points.length === 0 ? (
        <ChartEmpty message="최근 거래 데이터가 없어요." />
      ) : (
        <ResponsiveContainer width="100%" height={200}>
          <LineChart data={points} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis dataKey="ym" tick={{ fontSize: 11 }} />
            <YAxis
              tick={{ fontSize: 11 }}
              width={60}
              tickFormatter={(v: number) => `${Math.round(v)}만`}
            />
            <Tooltip formatter={(v: number) => [`${Math.round(v).toLocaleString()}만원/㎡`, '평균가']} />
            <Line
              type="monotone"
              dataKey="avgPrice"
              stroke="#ef4444"
              strokeWidth={2}
              dot={false}
              name="평균가"
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </ChartCard>
  );
}
